import React, {Component} from 'react'

const NO_STEPS = []

export function major(step) {
    return Math.trunc(step)
}

class Wizard {

    constructor(steps, activeStep) {
        this.steps = steps
        this.majorSteps = steps.map((s) => Math.trunc(s))
        this.activeStep = activeStep
        this.majorActiveStep = Math.trunc(activeStep)
        this.minorActiveStep = Math.round((activeStep % 1) * 10) / 10
    }

    nextStep() {
        const nextActiveStep = this.steps[this.majorSteps.indexOf(this.majorActiveStep) + 1]
        this._onActiveStepChange(nextActiveStep)
    }

    previousStep() {
        const nextActiveStep = this.steps[this.majorSteps.indexOf(this.majorActiveStep) - 1]
        this._onActiveStepChange(nextActiveStep)
    }

    setActiveStep(step) {
        const nextActiveStep = (step < 1) && (this.majorActiveStep + step) || step
        this._onActiveStepChange(nextActiveStep)
    }

    matchActiveStep(steps) {
        steps = (steps instanceof Array) && steps || [steps]
        return steps.indexOf(this.activeStep) >= 0 || steps.indexOf(this.majorActiveStep) >= 0 || steps.indexOf(this.minorActiveStep) >= 0
    }

    hasNextStep() {
        return this.majorSteps.indexOf(this.majorActiveStep) < (this.majorSteps.length - 1)
    }

    hasPreviousStep() {
        return this.majorSteps.indexOf(this.majorActiveStep) > 0
    }
}

function connectWizard(options) {
    const selectSteps = (typeof options.steps == 'function') && options.steps || (() => options.steps || NO_STEPS)
    const selectActiveStep = (typeof options.activeStep == 'function') && options.activeStep || ((s) => options.activeStep || s[0])

    return (WrappedComponent) => {

        class WizardConnector extends Component {

            constructor(props) {
                super(props)

                const steps = selectSteps(props)
                const activeStep = selectActiveStep(steps, props)
                const nextWizard = this._createWizard(steps, activeStep)

                this.state = {
                    wizard: nextWizard
                }

                this._steps = steps
                this._activeStep = activeStep
            }

            componentWillReceiveProps(nextProps) {
                const {wizard} = this.state

                const steps = selectSteps(nextProps)
                const activeStep = selectActiveStep(steps, nextProps)

                if (steps != this._steps || activeStep != this._activeStep) {
                    const nextActiveStep = (activeStep != this._activeStep) && activeStep || wizard.activeStep
                    const nextWizard = this._createWizard(steps, nextActiveStep)

                    this.setState({wizard: nextWizard})

                    this._steps = steps
                    this._activeStep = activeStep
                }
            }

            _createWizard(steps, activeStep) {
                const wizard = new Wizard(steps, activeStep)

                wizard._onActiveStepChange = (activeStep) => {
                    const nextWizard = this._createWizard(steps, activeStep)
                    this.setState({wizard: nextWizard})
                }

                return wizard
            }

            render() {
                return <WrappedComponent {...this.props} {...this.state} />
            }
        }

        return WizardConnector
    }
}

export {connectWizard}


// WEBPACK FOOTER //
// ./lib/core/wizard.js